export default __webpack_public_path__ + "static/media/NoteApp.de9cffbb.avif";